export const GA_TRACKING_ID = process.env.GA_TRACKING_ID || "" // This is your GA Tracking ID
export const GA4_TRACKING_ID = process.env.GA4_TRACKING_ID || "" // This is your GA Tracking ID
export const GTM_ID = process.env.GTM_ID

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: URL): void => {
  window.gtag("config", GA_TRACKING_ID, {
    page_path: url,
  })
}

type GTagEvent = {
  action: string
  category: string
  label: string
  value: number
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }: GTagEvent): void => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}
